import api from "../../../core/api";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

export interface ServiceProviderSettings {
  serviceRadiusKm?: number | null;
  baseLatitude?: number | null;
  baseLongitude?: number | null;
  effectiveLatitude?: number | null;
  effectiveLongitude?: number | null;
  hourlyRate?: number | null;
  travelRatePerKm?: number | null;
  travelRatePerHour?: number | null;
  warrantyPeriodCode?: number | null;
  customWarrantyPeriod?: string | null;
  paymentTermsCode?: number | null;
  customPaymentTerms?: string | null;
  validityPeriodCode?: number | null;
  customValidityPeriod?: string | null;
  includeDiagnostics?: boolean;
  includeLaborForRepair?: boolean;
  includePartsAndMaterials?: boolean;
  includeTestingAndCalibration?: boolean;
  includeWorkAreaCleanup?: boolean;
  includeDetailedServiceReport?: boolean;
  // Order deadline / business hours
  orderDeadlineEnabled?: boolean;
  orderDeadlineTime?: string | null;
  orderDeadlineTimezoneId?: string | null;
  usePerDayDeadlines?: boolean;
  mondayDeadlineTime?: string | null;
  tuesdayDeadlineTime?: string | null;
  wednesdayDeadlineTime?: string | null;
  thursdayDeadlineTime?: string | null;
  fridayDeadlineTime?: string | null;
  saturdayDeadlineTime?: string | null;
  sundayDeadlineTime?: string | null;
}

export interface ChangeServiceProviderSettings {
  serviceRadiusKm?: number | null;
  baseLatitude?: number | null;
  baseLongitude?: number | null;
  hourlyRate?: number | null;
  travelRatePerKm?: number | null;
  travelRatePerHour?: number | null;
  warrantyPeriodCode?: number | null;
  customWarrantyPeriod?: string | null;
  paymentTermsCode?: number | null;
  customPaymentTerms?: string | null;
  validityPeriodCode?: number | null;
  customValidityPeriod?: string | null;
  includeDiagnostics?: boolean;
  includeLaborForRepair?: boolean;
  includePartsAndMaterials?: boolean;
  includeTestingAndCalibration?: boolean;
  includeWorkAreaCleanup?: boolean;
  includeDetailedServiceReport?: boolean;
  // Order deadline / business hours
  orderDeadlineEnabled?: boolean;
  orderDeadlineTime?: string | null;
  orderDeadlineTimezoneId?: string | null;
  usePerDayDeadlines?: boolean;
  mondayDeadlineTime?: string | null;
  tuesdayDeadlineTime?: string | null;
  wednesdayDeadlineTime?: string | null;
  thursdayDeadlineTime?: string | null;
  fridayDeadlineTime?: string | null;
  saturdayDeadlineTime?: string | null;
  sundayDeadlineTime?: string | null;
}

export interface ProviderDeadlineInfo {
  isDeadlineEnabled: boolean;
  deadlineTime?: string | null;
  timezoneId?: string | null;
  isCurrentlyPastDeadline: boolean;
  timeUntilDeadline?: string | null;
}

class ServiceProviderPricingApi {
  getSettings(): Promise<ServiceProviderSettings> {
    return api
      .get<ServiceProviderSettings>(`/v1/customer/service-provider-settings`, getRequestConfig())
      .then((x) => x.data);
  }

  saveSettings(model: ChangeServiceProviderSettings): Promise<any> {
    return api
      .put(`/v1/customer/service-provider-settings`, model, getRequestConfig())
      .then(() => null);
  }

  getDeadlineInfo(): Promise<ProviderDeadlineInfo> {
    return api
      .get<ProviderDeadlineInfo>(`/v1/customer/service-provider-settings/deadline-info`, getRequestConfig())
      .then((x) => x.data);
  }
}

export default new ServiceProviderPricingApi();
